module.exports = __webpack_public_path__ + "static/media/35.e5a308c2.jpeg";